<template>
  <div class="grid grid-cols-12 gap-4">
    <div class="col-span-12">
      <div class="grid grid-cols-12 gap-4 pt-1">
        <div class="col-span-12">
          <div class="border-b border-gray-200">
            <nav class="flex space-x-6 px-4" aria-label="Tabs">
            <div :class="[(currentRoute == 'members') ? 'border-primary text-primary' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300', 'whitespace-nowrap py-3 px-1 border-b-2 font-medium text-sm flex items-center space-x-2 transition cursor-pointer']" @click="select('members')">
              <div class="flex mt-6">
                <div style="font-size: 14px">Members</div>
                <span class="bg-gray text-white px-2 py-1 rounded-sm text-xs bg-primary mb-1 mx-1 ">
                  {{society.members.length}}
                </span>
              </div>
            </div>
            <div :class="[(currentRoute == 'details') ? 'border-primary text-primary' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300', 'whitespace-nowrap py-3 px-1 border-b-2 font-medium text-sm flex items-center space-x-2 transition cursor-pointer']" @click="select('details')">
              <div class="flex mt-6">
                <div style="font-size: 14px">Address</div>
              </div>
            </div>
            <div :class="[(currentRoute == 'documents') ? 'border-primary text-primary' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300', 'whitespace-nowrap py-3 px-1 border-b-2 font-medium text-sm flex items-center space-x-2 transition cursor-pointer']" @click="select('documents')">
              <div class="flex mt-6">
                <div style="font-size: 14px">Documents</div>
                <span class="bg-gray text-white px-2 py-1 rounded-sm text-xs bg-primary mx-1 mb-1">
                  {{society.attachments.length}}
                </span>
              </div>
            </div>
            <div :class="[(currentRoute === 'filing-history') ? 'border-primary text-primary' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300', 'whitespace-nowrap py-3 px-1 border-b-2 font-medium text-sm flex items-center space-x-2 transition cursor-pointer']" @click="select('filing-history')">
              <div class="flex mt-6">
                <div style="font-size: 14px">Filing History</div>
              </div>
            </div>
            </nav>
          </div>
        </div>
      </div>
      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12">
          <div class="grid grid-cols-12 gap-4">
            <BuildingSocietyMembers :members="society.members" v-if="currentRoute === 'members'"/>
            <BuildingSocietyDetails :file="society" v-if="currentRoute === 'details'"/>
            <BuildingSocietyDocuments :documents="society.attachments" v-if="currentRoute === 'documents'"/>
            <FilingHistory :brn="society.brn" v-if="currentRoute == 'filing-history'"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import BuildingSocietyMembers
  from "@/domains/home/services/registry/business/files/tabs/building_society_data/BuildingSocietyMembers.vue";
import BuildingSocietyDetails
  from "@/domains/home/services/registry/business/files/tabs/building_society_data/BuildingSocietyDetails.vue";
import BuildingSocietyDocuments
  from "@/domains/home/services/registry/business/files/tabs/building_society_data/BuildingSocietyDocuments.vue";
import FilingHistory from "@/domains/home/services/registry/business/files/FilingHistory.vue";

defineProps<{ society: any }>();

const currentRoute = ref("members");

const select = (route: string) => {
  currentRoute.value = route;
}
</script>

